module.exports = function(value) {
	return value.replace(/[-_]/g, " ")
};
